/* 5RW Next · LP challenger · 2026-09-05 · no dependencies */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var target = document.getElementById('choose');

    /* 1. Every CTA scrolls to the selector (page-template sections have no #shopify-section wrapper on Shrine) */
    function scrollToChoose(e) {
      if (!target) return;
      e.preventDefault();
      var el = target.getBoundingClientRect().height ? target : target.parentElement;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#choose');
    }
    document.querySelectorAll('a[href="#choose"]').forEach(function (a) {
      a.addEventListener('click', scrollToChoose);
    });

    /* 2. Sticky mobile CTA: visible after the hero, hidden while the selector is on screen */
    var sticky = document.querySelector('.lp5-sticky');
    var hero = document.querySelector('.lp5-hero');
    var selector = document.querySelector('.lp5-products');
    if (sticky && hero && 'IntersectionObserver' in window) {
      var heroVisible = true;
      var selectorVisible = false;
      function update() {
        sticky.classList.toggle('is-visible', !heroVisible && !selectorVisible);
      }
      new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.05 }).observe(hero);
      if (selector) {
        new IntersectionObserver(function (entries) {
          selectorVisible = entries[0].isIntersecting;
          update();
        }, { threshold: 0.05 }).observe(selector);
      }
    }

    /* 3. Show all colors */
    document.querySelectorAll('[data-lp5-expand]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sec = btn.closest('.lp5-products');
        if (!sec) return;
        sec.classList.add('is-expanded');
        btn.parentElement.removeChild(btn);
      });
    });

    /* 4. Lightbox for the feeding photos */
    document.querySelectorAll('[data-lp5-lightbox]').forEach(function (box) {
      var id = box.getAttribute('data-lp5-lightbox');
      var triggers = document.querySelectorAll('[data-lp5-photo="' + id + '"]');
      var img = box.querySelector('.lp5-lightbox__img');
      var sources = [];
      triggers.forEach(function (t) {
        var s = t.querySelector('img');
        if (s) sources.push({ src: (s.currentSrc || s.src).replace(/width=\d+/, 'width=1600'), alt: s.alt || '' });
      });
      if (!sources.length || !img) return;
      var i = 0;
      function show(n) {
        i = (n + sources.length) % sources.length;
        img.src = sources[i].src;
        img.alt = sources[i].alt;
      }
      function open(n) { show(n); box.classList.add('is-active'); document.body.style.overflow = 'hidden'; }
      function close() { box.classList.remove('is-active'); document.body.style.overflow = ''; }
      triggers.forEach(function (t, n) {
        t.addEventListener('click', function () { open(n); });
        t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(n); } });
      });
      box.querySelector('.lp5-lightbox__close').addEventListener('click', function (e) { e.stopPropagation(); close(); });
      box.querySelector('.lp5-lightbox__prev').addEventListener('click', function (e) { e.stopPropagation(); show(i - 1); });
      box.querySelector('.lp5-lightbox__next').addEventListener('click', function (e) { e.stopPropagation(); show(i + 1); });
      box.addEventListener('click', function (e) { if (e.target === box) close(); });
      document.addEventListener('keydown', function (e) {
        if (!box.classList.contains('is-active')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(i - 1);
        if (e.key === 'ArrowRight') show(i + 1);
      });
      var sx = 0;
      box.addEventListener('touchstart', function (e) { sx = e.changedTouches[0].screenX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        var d = e.changedTouches[0].screenX - sx;
        if (Math.abs(d) > 50) show(d > 0 ? i - 1 : i + 1);
      }, { passive: true });
    });
  });
})();
